var map = {
	"./env.dev.js": 452,
	"./env.production.js": 453,
	"./env.staging.js": 183
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 773;


//////////////////
// WEBPACK FOOTER
// ./src/config ^\.\/env\..*\.js$
// module id = 773
// module chunks = 31